export default class AnchorLink {
  constructor(link, fixedContent) {
    this.$ = link;
    this.link = String(this.$.href);
    if(this.link.indexOf('#') != -1){
      this.linkURL = this.link.split('#')[0];
      this.linkHASH = this.link.split('#')[1];
    }else{
      this.linkURL = this.link;
      this.linkHASH = '';
    }

    this.page = location.href;
    if(this.page.indexOf('#') != -1){
      this.pageURL = this.page.split('#')[0];
      this.pageHASH = this.page.split('#')[1];
    }else{
      this.pageURL = this.page;
      this.pageHASH = '';
    }

    if(fixedContent){
      this.fixedCont = fixedContent;
      this.fixedContentHeight = this.fixedCont.clientHeight;
    }else{
      this.fixedContentHeight = 0;
    }

    if(this.linkHASH){
      this.bind();
    }
  }

  bind(){
    this.$.addEventListener('click', this.scroll.bind(this));
  }

  scroll(evt){
    if(document.getElementById(this.linkHASH)){
      evt.preventDefault();
      let anchorTarget = document.getElementById(this.linkHASH);
      window.scrollTo({
        top: anchorTarget.getBoundingClientRect().top + window.pageYOffset - this.fixedContentHeight,
        behavior: 'smooth',
      });
    }
  }

}
